'use strict';

// Assigned Dependencies

module.exports = (function() {
    $('.font-size-increase').click(function() {
      resizeText(1);
      setupCourseAccordionPadding();
    });

    $('.font-size-decrease').click(function() {
      resizeText(-1);
      setupCourseAccordionPadding();
    });
})();

function resizeText(multiplier) {
  $('.resizable-text').find('*').each(function() {
    var style = $(this).css('font-size');
    var fontSize = parseFloat(style);
    var mult = parseFloat(multiplier);
    /*
    12px for Arabic is due to html tag font-size set to 75% (see emportal\assets\frontend\styles\core\components\_right-to-left.scss)
    12px is 75% of 16px the browser's default font-size.
    10px is for non-Arabic - see emportal\assets\frontend\styles\core\components\_above-the-fold.scss line 1201
    */
    var divisor = ($("html").attr("lang") === "AR") ? 12 : 10;
    var result = parseFloat((fontSize + mult) / divisor);
    $(this).css('font-size',result + "rem");
  });
}